import BaseService from '../../base/base_service';
import _ from '../../utils/underscore';
import ExternalLinksController from '../../components/external_links/external_links_component_controller';
import * as EXTERNAL_LINKS_CONSTS from '../../components/external_links/external_links_consts';
import {SYSTEM_EVENTS} from '../../events/events';
import {RESPONSIBLE_GAMBLING_VIEW} from "./open_link_service_consts";
import {NAVIGATION_VIEWS} from "../../components/external_links/external_links_consts";

/**
 * GnwpService enables perform navigation / redirect appropriate to specified template and some additional parameters.
 * Template describes the service (web site) GNWP should redirect to.
 */
class OpenLinkService extends BaseService {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'OpenLinkService';


    /**
     * @property
     * @type {null}
     * @private
     */
    _model = null;


    /**
     *
     * @param params
     */
    init(params) {
        super.init(params);
        this._subscribe();
    }



    /**
     * Handle open external link event
     * @private
     */
    _subscribe() {
        this.onSystemEvent(SYSTEM_EVENTS.EXTERNAL_LINK_OPEN, (params) => {
           this.openLink(params);
        });
    }

    /**
     *
     * @params {object} linkParams {
     * source {string}  - link or predefined key to open
     * view {string} - target that link will be open in. Values: 'iframe', 'window'. Default for regular link is 'iframe', for predefined - see documentation
     * options {object}  - addinional parameters for link. Used for open page in specified mode
     * }
     *
     */
    openLink(linkParams) {
        if (!linkParams) {
            this.logger.warn('openLink called without parameters. Opening link was terminated');
            return;
        }
        let externalLinkComponent = ExternalLinksController.create(Object.assign(linkParams, {type: EXTERNAL_LINKS_CONSTS.COMPONENT_TYPES.API}));

        // execute open link
        return externalLinkComponent.openLink();
    }

    openResponsibleGamblingLink(responsibleGamblingView) {
        let link = this.serviceFactory.skinService().getResponsibleGamblingLink();

        if (!link) {
            this.logger.error('Responsible gambling link is not configured');
            return;
        }

        if(_.isNullOrUndefined(responsibleGamblingView)) {
            responsibleGamblingView = this.serviceFactory.gameManagerService().responsibleGamblingView();
        }

        let view;
        switch (responsibleGamblingView) {
            case RESPONSIBLE_GAMBLING_VIEW.IFRAME:
                view = NAVIGATION_VIEWS.IFRAME;
                break;
            case RESPONSIBLE_GAMBLING_VIEW.WINDOW:
                view = NAVIGATION_VIEWS.WINDOW;
                break;
            case RESPONSIBLE_GAMBLING_VIEW.REDIRECT:
                view = NAVIGATION_VIEWS.REDIRECT;
                break;
            default:
                view = NAVIGATION_VIEWS.WINDOW;
                break;
        }
        this.openLink({sourceLink: link, view: view});
    }
}

export default OpenLinkService;